interface ImpersonationCandidate {
    userId: number;
    displayName: string;
    email: string;
};

export function attachImpersonationSearch(container: HTMLElement): void {
    const input = container.querySelector<HTMLInputElement>("[data-role='query']");
    const results = container.querySelector<HTMLElement>("[data-role='results']");
    if (!input || !results) {
        return;
    }

    let debounceTimer: number;

    input.addEventListener("input", () => {
        window.clearTimeout(debounceTimer);
        results.innerHTML = "";

        const query = input.value.trim();
        if (query.length < 2) {
            return;
        }

        debounceTimer = window.setTimeout(() => {
            void fetch(`/Account/SearchImpersonationCandidates?query=${encodeURIComponent(query)}`)
                .then(response => response.json())
                .then((candidates: ImpersonationCandidate[]) => {
                    results.innerHTML = "";
                    candidates.forEach(candidate => {
                        const button = document.createElement("button");
                        button.type = "submit";
                        button.name = "targetUserId";
                        button.value = candidate.userId.toString();
                        button.className = "list-group-item list-group-item-action";
                        button.textContent = `${candidate.displayName} (${candidate.email})`;
                        results.appendChild(button);
                    });
                });
        }, 250);
    });
}